import { config } from "../config";
import { callGateway, type CallerIdentity } from "./gateway";

/**
 * New connection requests (owner 2026-11-02, radaccess): a customer on the
 * public sign-up page asks for a residential or commercial connection with an
 * address and pays after installation. Marking a request gives no plan and
 * takes no money. Installed takes the ONU's MAC (owner 2026-11-03): it becomes
 * the customer's login, and the customer then pays for the plan asked for.
 *
 *   GET /operator/{ns}/connection-requests[?closed=1]   subscriberrecharge:read
 *   PUT /operator/{ns}/connection-requests/{id}/status  subscriberrecharge:write
 */
export type ConnectionRequestStatus = "new" | "contacted" | "installed" | "declined";
export type ConnectionRequestDecision = Exclude<ConnectionRequestStatus, "new">;

export interface ConnectionRequest {
  id: number;
  mobile: string;
  name: string;
  groupname: string;
  plan_heading: string;
  address: string;
  city: string;
  state: string;
  pin: string;
  status: ConnectionRequestStatus;
  reason: string;
  decided_by: string;
  created: string;
}

const base = (ns: string) => `/operator/${encodeURIComponent(ns)}/connection-requests`;

export async function listConnectionRequests(identity: CallerIdentity, ns: string, closed: boolean, signal?: AbortSignal): Promise<ConnectionRequest[]> {
  const r = await callGateway<ConnectionRequest[] | null>(identity, config().gatewayBase, `${base(ns)}${closed ? "?closed=1" : ""}`, signal ? { signal } : {});
  return r.data ?? [];
}

/** Installed needs the ONU's MAC: it becomes the customer's login, paid for later. */
export async function decideConnectionRequest(identity: CallerIdentity, ns: string, id: number, status: ConnectionRequestDecision, reason: string, onu = ""): Promise<void> {
  const body: Record<string, string> = { status, reason: reason.trim() };
  if (status === "installed") body.onu = onu.trim();
  await callGateway<null>(identity, config().gatewayBase, `${base(ns)}/${id}/status`, { method: "PUT", body });
}
